var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheButton',{staticClass:"c-back-button",attrs:{"href":("/" + _vm.type + "/" + _vm.slug),"title":((_vm.$t('BACK_BUTTON_LINK')) + "  " + _vm.name)}},[_c('i',{staticClass:"arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }